var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.839966H2C0.89 0.839966 0.00999999 1.72997 0.00999999 2.83997L0 14.84C0 15.95 0.89 16.84 2 16.84H18C19.11 16.84 20 15.95 20 14.84V2.83997C20 1.72997 19.11 0.839966 18 0.839966ZM18 14.84H2V8.83997H18V14.84ZM18 4.83997H2V2.83997H18V4.83997Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid13);
export default __webpack_public_path__ + "static/media/grid13.6d230b1a24bc6973b00be9f3351b0c2f.svg";
export { ForwardRef as ReactComponent };